import React from 'react';
import ContactRootPage from '../contact';

function StoryblokContactRootPage(props) {
  return <ContactRootPage {...props} />;
}

export default StoryblokContactRootPage;
